import { fork } from 'redux-saga/effects';

import { productsSaga } from './views/Products';
import { checkoutSaga } from './views/Checkout';

export default function* rootSaga() {
  yield fork(productsSaga);
  yield fork(checkoutSaga);
}
